//CSS: Load Game style
import "../../assets/css/colors.css";
import "../../assets/css/game.css";
import "../../assets/css/draw.css";

//GAME:: Components
import Topbar from "../components/statusbars/topbar/Tobar";
import Draw from "../components/draw/Draw";
import Bet from "../components/bet/Bet";
import TicketSelector from "../components/ticket-selector/TicketSelector";
import Settings from "../components/statusbars/settings/Settings";
import Winners from "../components/winners/Winners";
import PopupWin from "../components/popups/win/Popup.Win";
import { useEffect } from "react";
import { __EventDispatcher, __Store } from "../../_core/core";
import { EventClass, EventType } from "../config/Events";
import { action_setUserInteraction } from "../../_core/store/actions/actions.App";
import FailedBets from "../components/popups/failed-bets/FailedBets";

export default function ScreenGame() {
  const onEventDispatched = (
    _eventClass: EventClass,
    _eventType: string,
    _eventPayload?: any
  ) => {
    if ([EventClass.INPUT].indexOf(_eventClass) === -1) return false;

    switch (_eventType) {
      case EventType.INPUT.CLICK:
        __Store.dispatch(action_setUserInteraction(true));
        break;
      case EventType.INPUT.KEY_DOWN:
        __Store.dispatch(action_setUserInteraction(true));
        break;
      case EventType.INPUT.KEY_PRESSED:
        __Store.dispatch(action_setUserInteraction(true));
        break;
      case EventType.INPUT.KEY_RELEASED:
        __Store.dispatch(action_setUserInteraction(true));
        break;
      case EventType.INPUT.KEY_UP:
        __Store.dispatch(action_setUserInteraction(true));
        break;
    }
  };

  useEffect(() => {
    __EventDispatcher.addListener(EventClass.INPUT, onEventDispatched, {});
  }, []);

  return (
    <>
      <Settings />
      <PopupWin />
      <FailedBets />
      <Topbar />
      <Winners />
      <Draw />
      <Bet />
      <TicketSelector />
    </>
  );
}
